import { render, staticRenderFns } from "./LeftNavBase.vue?vue&type=template&id=92b3bf68&scoped=true&"
import script from "./LeftNavBase.vue?vue&type=script&lang=js&"
export * from "./LeftNavBase.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavBase.vue?vue&type=style&index=0&id=92b3bf68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b3bf68",
  null
  
)

export default component.exports